import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const TableContactsStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-contacts",
})`
  .MuiFormControl-root {
    width: 100%;
  }

  .table-contacts__container {
    .display-mode {
      transition: filter 0.55s ease-out;
    }

    &[data-inner-editing="true"] {
      .display-mode {
        filter: blur(3px) grayscale(100%) !important;
        pointer-events: none !important;
        transition: filter 0.55s ease-out;
      }

      .add_item_button_wrapper .MuiButton-root {
        filter: blur(3px) grayscale(100%);
        pointer-events: none;
        transition: filter 0.55s ease-out;
      }
    }
  }
`;

export const TableContactsRow = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-contacts-row",
})``;
